import GroupAddOutlined from "@mui/icons-material/GroupAddOutlined";
import MenuBookOutlined from "@mui/icons-material/MenuBookOutlined";
import CalendarViewMonthOutlined from "@mui/icons-material/CalendarViewMonthOutlined";
import AccountBalanceWalletOutlined from "@mui/icons-material/AccountBalanceWalletOutlined";
import CampaignOutlined from "@mui/icons-material/CampaignOutlined";
import EmojiEventsOutlined from "@mui/icons-material/EmojiEventsOutlined";
import ForumOutlined from "@mui/icons-material/ForumOutlined";
import ShieldOutlined from "@mui/icons-material/ShieldOutlined";
import TableChartOutlined from "@mui/icons-material/TableChartOutlined";
import { APP_IDS } from "./routeAppMap";

/** Order in the app launcher grid. */
export const APP_SWITCHER_ORDER = [
  APP_IDS.LEADS,
  APP_IDS.ACADEMICS,
  APP_IDS.SCHEDULER,
  APP_IDS.FINANCE,
  APP_IDS.MARKETING,
  APP_IDS.PERFORMANCE,
  APP_IDS.COMMUNICATION,
  APP_IDS.ADMIN,
  APP_IDS.REPORTS,
];

const LAUNCHER_META = {
  [APP_IDS.LEADS]: {
    label: "Leads Manager",
    Icon: GroupAddOutlined,
    swatch: { bg: "linear-gradient(145deg, #e0e7ff 0%, #c7d2fe 100%)", fg: "#312e81", ring: "rgba(79, 70, 229, 0.35)" },
  },
  [APP_IDS.ACADEMICS]: {
    label: "Academics",
    Icon: MenuBookOutlined,
    swatch: { bg: "linear-gradient(145deg, #d1fae5 0%, #a7f3d0 100%)", fg: "#065f46", ring: "rgba(5, 150, 105, 0.35)" },
  },
  [APP_IDS.SCHEDULER]: {
    label: "Scheduler",
    Icon: CalendarViewMonthOutlined,
    swatch: { bg: "linear-gradient(145deg, #e0f2fe 0%, #bae6fd 100%)", fg: "#075985", ring: "rgba(2, 132, 199, 0.35)" },
  },
  [APP_IDS.FINANCE]: {
    label: "Finance",
    Icon: AccountBalanceWalletOutlined,
    swatch: { bg: "linear-gradient(145deg, #fef3c7 0%, #fde68a 100%)", fg: "#92400e", ring: "rgba(217, 119, 6, 0.4)" },
  },
  [APP_IDS.MARKETING]: {
    label: "Marketing",
    Icon: CampaignOutlined,
    swatch: { bg: "linear-gradient(145deg, #fce7f3 0%, #fbcfe8 100%)", fg: "#9d174d", ring: "rgba(219, 39, 119, 0.35)" },
  },
  [APP_IDS.PERFORMANCE]: {
    label: "Performance",
    Icon: EmojiEventsOutlined,
    swatch: { bg: "linear-gradient(145deg, #ffedd5 0%, #fed7aa 100%)", fg: "#9a3412", ring: "rgba(234, 88, 12, 0.4)" },
  },
  [APP_IDS.COMMUNICATION]: {
    label: "Communication",
    Icon: ForumOutlined,
    swatch: { bg: "linear-gradient(145deg, #ede9fe 0%, #ddd6fe 100%)", fg: "#5b21b6", ring: "rgba(124, 58, 237, 0.35)" },
  },
  [APP_IDS.ADMIN]: {
    label: "Admin",
    Icon: ShieldOutlined,
    swatch: { bg: "linear-gradient(145deg, #e2e8f0 0%, #cbd5e1 100%)", fg: "#1e293b", ring: "rgba(71, 85, 105, 0.45)" },
  },
  [APP_IDS.REPORTS]: {
    label: "Reports",
    Icon: TableChartOutlined,
    swatch: { bg: "linear-gradient(145deg, #fae8ff 0%, #f3e8ff 100%)", fg: "#6b21a8", ring: "rgba(126, 34, 206, 0.35)" },
  },
};

const FALLBACK = {
  label: "App",
  Icon: GroupAddOutlined,
  swatch: { bg: "#f1f5f9", fg: "#334155", ring: "rgba(100, 116, 139, 0.35)" },
};

export function getAppLabel(appId) {
  return LAUNCHER_META[appId]?.label || appId;
}

export function getAppSwitcherIcon(appId) {
  return LAUNCHER_META[appId]?.Icon || FALLBACK.Icon;
}

export function getAppLauncherMeta(appId) {
  return LAUNCHER_META[appId] || { ...FALLBACK, label: getAppLabel(appId) };
}

export function getAllAppDefinitions() {
  return APP_SWITCHER_ORDER.map((key) => ({
    key,
    label: getAppLabel(key),
    Icon: getAppSwitcherIcon(key),
    swatch: getAppLauncherMeta(key).swatch,
  }));
}
